import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBox } from '@fortawesome/free-solid-svg-icons';
import {
  updateArchiveServiceSetting as updateArchiveServiceSettingApi
} from "../../../../../api/clients/archiveServices";
import { Link } from "react-router-dom";
import { ARCHIVE_SERVICE_DELETED_STATUSES, ARCHIVE_SERVICE_STATUSES } from "../../../../../config/constants";
import { NOTIFICATION_ARCHIVE_SERVICE_ACTIONS } from '../../../../../config/notifications';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function DezactivateArchiveService(props) {
  const [ showDeleteModal, setShowDeleteModal ] = useState( false );

  const { index, actionCallback, archiveServiceSetting, showIcon } = props;

  const dezactivateArchiveService = () => {
    updateArchiveServiceSettingApi( {
      archiveServiceSettingId: archiveServiceSetting.id,
      data: {
        status: ARCHIVE_SERVICE_STATUSES.DISABLED_BY_MYSIGN_ADMIN,
      },
      notificationId: NOTIFICATION_ARCHIVE_SERVICE_ACTIONS
    } ).then( (response) => {
      setShowDeleteModal( false );

      if (response?.data?.id) {
        actionCallback();
      }
    } );
  };

  const shouldDisplay = (archiveServiceSetting) => {
    // Don't show deactivate button if service doesn't exist, is already disabled, or is disabled by admin
    return (! archiveServiceSetting?.id || ARCHIVE_SERVICE_DELETED_STATUSES.includes( archiveServiceSetting?.status ) ) ? false : true;
  }

  if (! shouldDisplay( archiveServiceSetting )) {
    return null;
  }

  return ( <Fragment>
      {! showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`deactivate-archive-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowDeleteModal( true )
            }}
          >
            <FormattedMessage
              id="components.pages.organizations.table.actionButtons.dezactivate_archive_service"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`deactivate-archive-icon-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            <FormattedMessage
              id="components.pages.organizations.table.actionButtons.dezactivate_archive_service"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`deactivate-archive-icon-` + props.index}
            onClick={() => setShowDeleteModal( true )}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faBox}
            />
            <FontAwesomeIcon
              size="lg"
              className="pt-1 cursor-pointer"
              pointerEvents="none"
              icon={faTimes}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`deactivate-archive-icon-${props.index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            <FormattedMessage
              id="components.pages.organizations.table.actionButtons.dezactivate_archive_service"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showDeleteModal}
        closeModal={() => setShowDeleteModal( false )}
        confirmationYes={dezactivateArchiveService}
        messageId="components.layout.confirmation.body.deactivate_archive_service"
      />
    </Fragment>
  );
}

export { DezactivateArchiveService };
